import { User } from 'src/global/models/User';

import { StepNames } from '../constants';

// Like mobile, read the server's onboarding visibility flags. DST only blocks
// on roles and locations; other steps retain their existing Skip behavior.
export const getMissingMandatorySteps = (
  user: Partial<Pick<User, 'metadata'>>
): StepNames[] => {
  const onboarding = user.metadata?.onboarding;
  const steps: StepNames[] = [];
  if (onboarding?.showJobRoles) steps.push(StepNames.JobInterest);
  if (onboarding?.showJobLocations) steps.push(StepNames.JobPreferences);
  return steps;
};
